module.exports = __webpack_public_path__ + "img/34.80468165.jpg";